let elements = {
  blockCheck: true,
  mainImage: {
    imagePath: 'games/page061_game0/img/bcg.png',
    width: 1920,
    height: 1080,
    pos: {
      x: 0,
      y: 0,
    },
  },
  audio: {
    click: 'games/page061_game0/audio/click.mp3',
  },
  staticPos: {
    x: [100, 1400],
    y: [0, 80, 160, 240, 320, 400, 480, 560, 640],
  },
  puzzle: {
    width: 800,
    height: 800,
    src: 'games/page061_game0/img/00.jpg',
    numerOfX: 4,
    numerOfY: 4,
  },
};

export default elements;
